import { updateObject } from 'utils/updateObject'
import { fromJS } from 'immutable'
import setFilters from 'store/reducer-utils/setFilters'
import {
  NETWORK_ACCOUNTS_CLEAN,
  NETWORK_SET_SORTING,
  REMOVE_NETWORK_ACCOUNTS,
  RESET_NETWORK_DATA,
  SET_ACCOUNTS_FILTERS,
  SET_NETWORK_ACCOUNTS,
  SET_NETWORK_ACCOUNTS_QUERY,
  SET_NETWORK_DATA,
  SET_NETWORK_TEXT,
  SET_SELECTION,
  TOGGLE_PROCESSING,
  UPDATE_ACCOUNT_BY_ID,
  UPDATE_ACCOUNTS,
} from 'modules/Services/types'

const initialState = {
  order: null,
  has_account: false,
  loading: true,
  type: null,
  id: null,
  can_create_accounts: false,
  notifications: [],
  balance: {
    amount: null,
    currency: null,
  },
  bonus: 0,
  actions: [],
  texts: [],
  selection: { ids: [], processing: false },
  filters: null,
  accounts: {
    composedParams: {},
    state: [],
    loading: false,
    loaded: false,
    data: [],
    sorting: {
      prop: 'created_at',
      direction: 'asc',
    },
    pagination: {
      offset: 0,
      limit: 50,
      total: 0,
    },
  },
}

const setData = (state, { payload }) => updateObject(state, payload)

const setText = (state, { payload }) => {
  const currentTexts = fromJS(state.texts)
  const index = state.texts.findIndex((text) => text.key === payload.key)

  const updatedTexts = currentTexts.update(index, (text) => ({
    ...(text ? text.toJS() : {}),
    ...payload,
  }))

  return updateObject(state, {
    texts: updatedTexts.toJS(),
  })
}

const setSorting = (state, { payload }) =>
  updateObject(state, { accounts: { ...state.accounts, sorting: payload } })

const setAccounts = (state, { payload }) =>
  updateObject(state, {
    accounts: {
      ...state.accounts,
      loading: false,
      loaded: true,
      data: [...state.accounts.data, ...payload.data].filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.id === value.id),
      ),
      pagination: {
        ...state.accounts.pagination,
        total: payload.pagination.total,
      },
    },
  })

const updateAccounts = (state, { payload }) =>
  updateObject(state, {
    accounts: {
      ...state.accounts,
      ...payload,
    },
  })

const setSelection = (state, { payload }) =>
  updateObject(state, {
    selection: {
      ...state.selection,
      ids: payload,
    },
  })

const accountsClean = (state) =>
  updateObject(state, {
    accounts: {
      ...state.accounts,
      loading: false,
      data: [],
      pagination: {
        limit: 50,
        offset: 0,
        total: 0,
      },
    },
  })

const accountsQuery = (state, { payload }) => setFilters(state, { payload })

const dropNetworkData = () => initialState

const removeNetworkAccounts = (state, { payload }) =>
  updateObject(state, {
    accounts: {
      ...state.accounts,
      data: state.accounts.data.filter(({ id }) => !payload.includes(id)),
      pagination: {
        ...state.accounts.pagination,
        total: state.accounts.pagination.total - payload.length,
      },
    },
    selection: {
      processing: false,
    },
  })

const setAccountsFilters = (state, action) => {
  const filteredPayload = state?.filters
    ? [...action.payload].filter(
        (filter) => Object.keys(state.filters).indexOf(filter.fieldName) > -1,
      )
    : action.payload

  return setFilters(state, { ...action, payload: filteredPayload })
}

const toggleProcessing = (state, { payload }) =>
  updateObject(state, {
    ...state,
    selection: {
      ...state.selection,
      ...payload,
    },
  })

const updateAccountByID = (state, { payload: { id, update } }) => {
  const currentData = [...state['accounts'].data]
  const index = currentData.findIndex((acc) => acc.id === id)

  currentData[index] = { ...currentData[index], ...update }

  return updateObject(state, {
    accounts: {
      ...state.accounts,
      data: [...currentData],
    },
  })
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NETWORK_DATA:
      return setData(state, action)
    case RESET_NETWORK_DATA:
      return dropNetworkData()
    case SET_NETWORK_ACCOUNTS:
      return setAccounts(state, action)
    case SET_NETWORK_TEXT:
      return setText(state, action)
    case SET_NETWORK_ACCOUNTS_QUERY:
      return accountsQuery(state, action)
    case NETWORK_SET_SORTING:
      return setSorting(state, action)
    case UPDATE_ACCOUNTS:
      return updateAccounts(state, action)
    case SET_SELECTION:
      return setSelection(state, action)
    case NETWORK_ACCOUNTS_CLEAN:
      return accountsClean(state)
    case REMOVE_NETWORK_ACCOUNTS:
      return removeNetworkAccounts(state, action)
    case SET_ACCOUNTS_FILTERS:
      return setAccountsFilters(state, action)
    case TOGGLE_PROCESSING:
      return toggleProcessing(state, action)
    case UPDATE_ACCOUNT_BY_ID:
      return updateAccountByID(state, action)
    default:
      return state
  }
}

export default reducer
